/* istanbul ignore file */

import { useRichRelevance } from '@noths/polaris-client-react-hooks';
import { Placement } from '@noths/polaris-client-ribbons-design-system';
import { getProductIdFromProductCode } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import { requestSimilarProducts } from 'src/redux/richRelevance/thunks';
import { getStore } from 'src/redux/store';
import { NextConfig } from 'src/types';

const { publicRuntimeConfig } = getConfig() as NextConfig;

export const useAddToCartPlacement = (
  richRelevanceSessionId: string | undefined,
  code: number,
  isModalOpen: boolean,
) => {
  const { dispatch } = getStore();

  useRichRelevance(
    {
      API_KEY: publicRuntimeConfig.RICH_RELEVANCE_API_KEY,
      endpoint: publicRuntimeConfig.endpoints.richRelevance,
      sessionId: richRelevanceSessionId,
    },
    async (singleton) => {
      singleton.addPlacementRequestToQueue(
        {
          placements: [Placement.AddToCart],
          cartItemId: String(getProductIdFromProductCode(code)),
        },
        async (placements) => {
          const placement = placements.find(
            (placement) => placement.placement_name === Placement.AddToCart,
          );

          if (placement) {
            await dispatch(requestSimilarProducts(placement));
          }
        },
      );

      await singleton.runRequestsInQueue();
    },
    isModalOpen,
  );
};
